var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./VueDisqus.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler?id=data-v-611a2994!../vue-loader/lib/selector?type=template&index=0!./VueDisqus.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-disqus/VueDisqus.vue
// module id = 621
// module chunks = 1